import React, { useEffect, useState, useRef } from 'react';
import { Button, Tabs } from 'antd';
import { useHistory } from 'react-router';
import { Translation } from 'react-i18next';
import { get } from 'lodash';
import * as consts from '../consts';
import AuthenticateContainer from '../containers/AuthenticateContainer';
import {
  OpenOrderExchangeContainer,
} from '../containers/OrderContainer';

import {
  OrderBuyLimitContainer,
  OrderMarketContainer,
  OrderSellLimitContainer,
  OrderStopLimitContainer,
} from '../containers/OrderFormContainer';

export default function RightPanelComponent(props) {
  const history = useHistory();
  const [tradeType, setTradeType] = useState('Buy');
  const [orderType, setOrderType] = useState('Limit');

  useEffect(() => {
    setOrderType(props.orderType);
    setTradeType(props.tradeType === 'Buy' ? 'Sell' : 'Buy');
  }, [props.orderType, props.tradeType, props.clickOrderBook]);

  useEffect(() => {
    if (orderType === (window.$t('exchange.right_panel.market')) || orderType === 'Market') {
      window.$heightNotification = 268;
    } else if (orderType === (window.$t('exchange.right_panel.limit')) || orderType === 'Limit') {
      window.$heightNotification = 380;
    } else {
      window.$heightNotification = 436;
    }
  }, [orderType]);

  return (
    <Translation>
      {(t) => (
        <div className="panel text-left">
          <AuthenticateContainer auth={false}>
            <div className="ph-small">
              <div className="panel-header">
                {t('exchange.right_panel.start_trading')}
              </div>
              <div className="panel-body">
                <div className="text-center">
                  <Button
                    type="primary"
                    className="w-100 ln-normal btn"
                    onClick={() => history.push(`${consts.PREFIX_FRONT_URL}/login`)}
                  >
                    {t('exchange.right_panel.login')}
                  </Button>
                </div>
                <p className="panel-title">
                  {t('exchange.right_panel.welcome_sonek')}
                </p>
                <div className="h4">
                  <p>
                    {t('exchange.right_panel.the_exchange')}
                  </p>
                  <p>
                    {t('exchange.right_panel.we_through')}
                  </p>
                  <p>
                    {t('exchange.right_panel.slogan')}
                  </p>
                  <ul className="ulist">
                    <li>
                      {t('exchange.right_panel.volume_based_structure')}
                    </li>
                    <li>
                      {t('exchange.right_panel.high_engine')}
                    </li>
                    <li>
                      {t('exchange.right_panel.fix,_connectivity')}
                    </li>
                    <li>
                      {t('exchange.right_panel.24/7_support')}
                    </li>
                    <li>
                      {t('exchange.right_panel.industry_leading_practices')}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="panel-footer" />
            </div>
          </AuthenticateContainer>
          <AuthenticateContainer auth>
            <div className="order-open">
              <div className={tradeType === 'Buy' ? 'order-open-custom custom-buy ' : 'order-open-custom custom-sell'}>
                <Tabs

                  type="line"
                  style={{ textAlign: 'left', width: '100%' }}
                  tabBarGutter={20}
                  tabBarStyle={{
                    color: '#76808F',
                    borderWidth: 0,
                    borderStyle: 'solid',
                    paddingLeft: 0,
                    marginBottom: 3,
                    background: '#202124',
                    borderRadius: 3,
                    padding: '0px 10px',
                  }}
                  activeKey={tradeType}
                  animated={{ inkBar: true, tabPane: false }}
                  onChange={(tradeType) => {
                    setTradeType(tradeType);
                  }}
                  tabBarExtraContent={(
                    <div className="bold">
                      {t('exchange.right_panel.new_order')}
                    </div>
                  )}
                >
                  <Tabs.TabPane tab={t('exchange.right_panel.buy')} key="Buy">
                    <Tabs
                      type="line"
                      style={{ textAlign: 'left', width: '100%' }}
                      tabBarGutter={12}
                      tabBarStyle={{
                        color: '#76808F',
                        borderWidth: 0,
                        borderStyle: 'solid',
                        padding: '0px 10px',
                        background: '#202124',
                        marginBottom: -5,
                      }}
                      onChange={(orderType) => {
                        setOrderType(orderType);
                      }}
                      activeKey={orderType}
                      animated={{ inkBar: true, tabPane: false }}
                    >
                      <Tabs.TabPane tab={t('exchange.right_panel.market')} key="Market">
                        <OrderMarketContainer
                          coin={props.coin}
                          currency={props.currency}
                          tradeType={window.c.ORDER_TRADE_TYPE_BUY_STR}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('exchange.right_panel.limit')} key="Limit">
                        <OrderBuyLimitContainer
                          coin={props.coin}
                          currency={props.currency}
                          lastPrice={get(props.mapCurrencyMarkets, [props.currency, props.coin, 'last_price'], 0)}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('exchange.right_panel.stop')} key="Stop">
                        <OrderStopLimitContainer
                          coin={props.coin}
                          currency={props.currency}
                          tradeType={window.c.ORDER_TRADE_TYPE_BUY_STR}
                          lastPrice={get(props.mapCurrencyMarkets, [props.currency, props.coin, 'last_price'], 0)}
                        />
                      </Tabs.TabPane>
                    </Tabs>
                  </Tabs.TabPane>

                  <Tabs.TabPane tab={t('exchange.right_panel.sell')} key="Sell">
                    <Tabs
                      type="line"
                      style={{ textAlign: 'left', width: '100%' }}
                      tabBarGutter={12}
                      tabBarStyle={{
                        color: '#76808F',
                        borderWidth: 0,
                        borderStyle: 'solid',
                        padding: '0px 10px',
                        background: '#202124',
                        marginBottom: -5,
                        width: '100%',
                      }}
                      onChange={(orderType) => {
                        setOrderType(orderType);
                      }}
                      activeKey={orderType}
                      animated={{ inkBar: true, tabPane: false }}
                    >
                      <Tabs.TabPane
                        tab={
                          t('exchange.right_panel.market')
                        }
                        key="Market"
                      >
                        <OrderMarketContainer
                          coin={props.coin}
                          currency={props.currency}
                          tradeType={window.c.ORDER_TRADE_TYPE_SELL_STR}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('exchange.right_panel.limit')} key="Limit">
                        <OrderSellLimitContainer
                          coin={props.coin}
                          currency={props.currency}
                          lastPrice={get(props.mapCurrencyMarkets, [props.currency, props.coin, 'last_price'], 0)}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('exchange.right_panel.stop')} key="Stop">
                        <OrderStopLimitContainer
                          coin={props.coin}
                          currency={props.currency}
                          tradeType={window.c.ORDER_TRADE_TYPE_SELL_STR}
                          lastPrice={get(props.mapCurrencyMarkets, [props.currency, props.coin, 'last_price'], 0)}
                        />
                      </Tabs.TabPane>

                    </Tabs>
                  </Tabs.TabPane>
                </Tabs>
              </div>
              <OpenOrderExchangeContainer orderClick={props.orderClick} />
            </div>
          </AuthenticateContainer>
        </div>
      )}
    </Translation>
  );
}
